import React from "react";
import styled from "@emotion/styled";
import { Toggle } from "kompare-ui-library";
import { Divider, Flex, Grid, Label, Tag, Text } from 'src/components';
import { colors } from "src/theme";
import { formatNumber, i18n, mediaQuery } from "src/common";

const Logo = styled.img({
  maxHeight: '48px',
  minHeight: '26px',
  maxWidth: '142px'
})

const TextAlignStyle = styled.div({
  textAlign: 'right'
})

const GridStyle = styled(Grid)({
  gridTemplateColumns: '1fr auto',

  [mediaQuery('mobile')]: {
    gridTemplateColumns: '1fr auto auto',
  },
})

const DividerStyle = styled(Divider)({
  display: 'none',

  [mediaQuery('mobile')]: {
    display: 'block',
  },
})

const LabelStyle = styled(Label)({
  display: 'none',

  [mediaQuery('mobile')]: {
    display: 'block',
  },
})

interface OfferHeaderCardProps {
  brandName?: string; // sa summarya saljem brandCode jer je isto groupama kao i brandNama, razlikuju se stvari koje dolaze s BE na ta dva poziva
  offerLabel?: string;
  price?: number;
  priceType?: 'monthly' | 'yearly';
  discountPercentage?: number;
  logoUrl?: string;
  className?: string;
  handlePriceTypeChange?: () => void;
}

// zove se card iako je samo dio carda - Header
export const OfferHeaderCard = ({ offerLabel, price, priceType, discountPercentage = 0, logoUrl, handlePriceTypeChange, brandName }: OfferHeaderCardProps) => (
  <>
    <Grid columns='auto 1fr' columnGap={16} align='center'>
      <Logo src={logoUrl} alt="logo" />
      <TextAlignStyle>
        <Text type='xLarge' bold>{`${formatNumber(price)}€`}</Text>
        <Text type='tiny' color={colors.text3}>{i18n.t(`components.cards.offerHeaderCard.${priceType}`)}</Text>
      </TextAlignStyle>
    </Grid>
    <DividerStyle dashed />
    <GridStyle columnGap={8} align='center'>
      <LabelStyle type='small'>{offerLabel}</LabelStyle>
      <Flex gap={4} align='center'>
        <Text type='tiny' color={colors.text3}>{i18n.t(`components.cards.offerHeaderCard.${brandName?.toLowerCase() === 'groupama' ? 'totalYearlyGeneral' : 'totalYearly'}`)}</Text>
        {discountPercentage > 0 && <Tag value={`${discountPercentage}% uštede`} background={colors.success2} />}
      </Flex>
      <Toggle checked={priceType === 'yearly'} onChange={handlePriceTypeChange} labelMarginBottom='0px' />
    </GridStyle>
  </>
)